import { formatEther, parseEther, parseUnits } from 'ethers';
import { TFunction } from 'next-i18next';
import { LendingPlanEnum } from '~/enums/lending-plan.enum';
import { LendingContractData, LendingData } from '~/hooks/with-lending-data';

export const getLendingPlanDurationTitle = (plan: string, t: TFunction) => {
  switch (plan) {
    case LendingPlanEnum.SEED:
      return t('lending_page.plan_duration_title', { month: 1, day: 30 });
    case LendingPlanEnum.SPROUT:
      return t('lending_page.plan_duration_title', { month: 3, day: 90 });
    case LendingPlanEnum.HARVEST:
      return t('lending_page.plan_duration_title', { month: 6, day: 180 });

    default:
      return '';
  }
};

export const getLendingUsdtxReward = (lendingData: LendingContractData, jocAmount: bigint) => {
  return BigInt(
    Math.floor(
      ((Number(lendingData.numeratorRewardRate) / Number(lendingData.denominatorRewardRate)) *
        Number(jocAmount)) /
        10 ** Number(lendingData.decimalConversationRate),
    ),
  );
};
